import store from "./store";

const actionHelper = (typeInput:string,payloadInput:any) => {
    store.dispatch({type: typeInput, payload: payloadInput})
}

export default actionHelper